const rankings = [
  {
    rank: 1,
    title: '顶流男星深夜密会神秘女子，酒店同框照曝光',
    heat: '1289万',
    trend: 'up',
    tag: '娱乐圈',
  },
  {
    rank: 2,
    title: '知名企业家涉嫌财务造假，公司股价暴跌30%',
    heat: '1056万',
    trend: 'up',
    tag: '社会',
  },
  {
    rank: 3,
    title: '女星婚礼变闹剧，前男友现场播放私密视频',
    heat: '987万',
    trend: 'up',
    tag: '娱乐圈',
  },
  {
    rank: 4,
    title: '国际大牌代言人塌房，品牌方6小时内紧急解约',
    heat: '843万',
    trend: 'stable',
    tag: '品牌',
  },
  {
    rank: 5,
    title: '头部主播合约纠纷升级，双方各执一词互不相让',
    heat: '721万',
    trend: 'down',
    tag: '平台',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            🏆 热度榜单
          </h2>
          <p className="text-sm text-foreground-600">
            实时更新的热门爆料排行，看看今天大家都在关注什么
          </p>
        </div>
        <div className="space-y-3">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 bg-background-50 border border-background-200/60 rounded-xl p-4 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                    ? 'bg-accent-500 text-accent-950'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="font-medium text-sm text-foreground-900 truncate">
                  {item.title}
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span
                  className={`text-xs font-medium ${
                    item.trend === 'up'
                      ? 'text-primary-500'
                      : item.trend === 'down'
                      ? 'text-foreground-400'
                      : 'text-accent-500'
                  }`}
                >
                  <i
                    className={`${
                      item.trend === 'up'
                        ? 'ri-arrow-up-line'
                        : item.trend === 'down'
                        ? 'ri-arrow-down-line'
                        : 'ri-subtract-line'
                    } mr-0.5`}
                  ></i>
                </span>
                <div className="text-sm font-bold text-primary-600 whitespace-nowrap">
                  {item.heat}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}